<template>
  <!-- <el-empty description="暂无数据"></el-empty> -->
  <!-- image="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png" -->
  <el-empty
    image="/img/NoData.png"
    :image-size="240"
    description="抱歉，鹅宝宝没有找到数据"
  ></el-empty>
</template>

<script>
export default {};
</script>

<style>
</style>